
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import bannerImg from "../../../../../../assets/images/ActivationHomeBanner.png";
// import smallBannerImg from "../../../../../../assets/images/New-Dealer-Portal-Banner.png"
// import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
// import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

// import dealerIcon from "../../../../../../assets/images/dealer-support.png";
// import managerIcon from "../../../../../../assets/images/account-manager.png";
// import speedIcon from "../../../../../../assets/images/5G-network.png";
// import networkIcon from "../../../../../../assets/images/network.png";
// import qrIcon from "../../../../../../assets/images/qr-code.png";
// import fourGIcon from "../../../../../../assets/images/4G.png";
// import fiveGIcon from "../../../../../../assets/images/5G.png";
// import mailIcon from "../../../../../../assets/images/Mail.png";
// import phoneIcon from "../../../../../../assets/images/Phone.png";
// import { getApiHeader } from 'utlis/commonfunctions';
// import Loader from './loader';

// function HomeScreen({ nextStep }) {
//   const SERVER_URL = process.env.REACT_APP_API_URL;
//   const [planData, setPlanData] = useState({});
//   const [portinData, setPortinData] = useState([]);
//   const [activationData, setActivationData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

       





//   useEffect(() => {
//     handleInitalLoad();
//   }, []);

// const PLAN_ORDER = [16, 17, 18, 13, 19];

// const rank = (id) => {
//   const i = PLAN_ORDER.indexOf(id);
//   return i === -1 ? PLAN_ORDER.length : i;
// };



//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth <= 768);
//     };
  
//     window.addEventListener('resize', handleResize);
  
//     // Cleanup on unmount
//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);





//   const handleInitalLoad = async () => {
//   setLoading(true);
//   const headers = await getApiHeader();
//   try {
//     const response = await axios.post(`${SERVER_URL}wme-prepaid-activation/offerplan`, {}, { headers: headers });
//     setPlanData(response?.data.data);

//     const portInArray = Object.entries(response.data.data.portIn)
//       .map(([amount, credit]) => ({
//         amount: parseInt(amount),
//         credit,
//       }))
//       .sort((a, b) => rank(a.amount) - rank(b.amount));

//     const activationArray = Object.entries(response.data.data.activation).map(([amount, credit]) => ({
//       amount: parseInt(amount),
//       credit,
//     }));

//     setPortinData({ portInArray, activationArray });

//     const activationCreditAmountArray = [...(response?.data?.data?.activation_total_credit_amount || [])]
//       .sort((a, b) => rank(a.plan_id) - rank(b.plan_id));

//     setActivationData(activationCreditAmountArray);
//     setLoading(false);
//   } catch (error) {
//     setLoading(false);
//     console.log("error", error);
//   }
// };
//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <div>
//         <section id="hero-2" className="hero-2 d-flex align-items-center col-lg-12">
//           {loading === true && <Loader />}
//           <div className="container-fluid">
//             <div className="hero-border">
//               <div className="hero-background">
//                 <>
//                   {isSmallScreen ? (
//                     <img
//                       src={smallBannerImg}
//                       className="img-fluid banner-img"
//                       style={{ borderRadius: "5px" }}
//                       alt="Small Banner"
//                     />
//                   ) : (
//                     <img
//                       src={bannerImg}
//                       className="img-fluid banner-img"
//                       style={{ borderRadius: "5px" }}
//                       alt="Large Banner"
//                     />
//                   )}
//                 </>

//               </div>
//             </div>
//           </div>
//         </section>
//         <br />



//         <div className="formbold-main-wrapper">
//           <div className="container py-4">
//             <div className="row">
//               {/* PORT-INS Category */}
//               <div className="col-md-12 col-lg-6 mb-4">
//                 <div className="text-center mb-3">
//                   <h5 className="fw-bold">PORT-INS</h5>
//                   <p className="activation-new-margin-heading">NOW FREE {planData?.port_in_unlimited_limit_count}% MARGIN</p>
//                 </div>

//                 {portinData?.portInArray?.map((item) => {
//                   return (
//                     <div
//                       className="d-flex flex-column flex-md-col flex-lg-row align-items-center rounded p-3 mb-3"
//                       style={{ border: "1px solid #c11d6c" }}
//                     >
//                       <div className="amount-color mb-3 mb-md-0">
//                       <h2>${item?.amount == 13 && "29.90"}{item?.amount == 16 && "25.00"}{item?.amount == 17 && "35.00"}{item?.amount == 18 && "33.00"}{item?.amount == 19 && "55.00"}  <span style={{fontSize:"20px"}}>{10}GB </span>
//                               </h2>
//                       </div>
//                       <div className="network-img mb-3 mb-md-0">
//                         <img src={fiveGIcon} alt="5G" />
//                       </div>
//                       <div className="responsive-activation-container" style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
//                       <table className="table table-borderless">
//                         <tbody>
//                           <tr>
//                             <td>
//                               <p style={{ textAlign: "center"}} className="new-font-activation">
//                                 <strong style={{ fontWeight: "900", fontSize: "20px" }}>
//                                   {item?.credit}
//                                 </strong>{" "}
//                                 Credits Remaining
//                               </p>
//                             </td>
//                           </tr>
//                           <tr>
//                              {item?.amount == 13 && (
//                               <td>
//                                 <button className="btn btn-amount-card">Data Only plan</button>
//                               </td>
//                             )}
//                             <td>
                              
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>

//               {/* NEW ACTIVATION Category */}
//               <div className="col-md-12 col-lg-6 mb-4">
//                 <div className="text-center mb-3">
//                   <h5 className="fw-bold">NEW ACTIVATION</h5>
//                   <p className="activation-new-margin-heading">
//                     NOW {planData?.voucher_activation_plan_id_16_percentage}% MARGIN
//                   </p>
//                 </div>

//                 {activationData?.map((item) => {
//                   return (
//                     <div
//                       className="d-flex flex-column flex-md-col flex-lg-row align-items-center rounded p-3 mb-3"
//                       style={{ border: "1px solid #c11d6c" }}
//                     >
//                       <div className="amount-color mb-3 mb-md-0">
//                         <h2>
//                          ${item?.actual_amount?.toFixed(2)} <span style={{fontSize:"20px"}}>{10}GB </span>
//                         </h2>

//                       </div>
//                       <div className="network-img mb-3 mb-md-0">
//                         <img src={fiveGIcon} alt="5G" />
//                       </div>
//                       <div className="responsive-activation-container" style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
//                       <table className="table table-borderless">
//                         <tbody>
//                           <tr>
//                             <td>

//                             {item?.credits > 0 ?

//                                 <p style={{ textAlign: "center" }} className="new-font-activation">
                                   
//                                   <strong style={{ fontWeight: "900", fontSize: "20px" }}> {item?.credits} </strong>

//                                   {item?.credits > 1 ? <> Credits </> : <> Credit </> } Remaining

//                                 </p>

//                                 :
                                
//                                 <p style={{ textAlign: "center" }} className="new-font-activation">
//                                    Only for <span></span>
//                                   <strong style={{ fontWeight: "900", fontSize: "20px" }}>
//                                      ${item?.amount}
//                                   </strong>
//                                 </p>

//                             }

//                             </td>
//                           </tr>
//                           <tr>
                         
//                             {item?.plan_id == 13 && (
//                               <td>
//                                 <button className="btn btn-amount-card">Data Only plan</button>
//                               </td>
//                             )}
                            
//                           </tr>
//                         </tbody>
//                       </table>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "10px", cursor: "pointer", zIndex: 1000 }}>
//     <button className="btn btn-amount-card" onClick={() => { nextStep() }}>Activate Prepaid SIM</button>
// </div>


//         <p className='plans-notes' style={{textAlign:"center",color:"#C11D6C",fontSize: "15px", padding:"10px"}}>Note: Please use $2 starter pack to avail credits.</p>

//         <section className="service-square-box">
//           <div className="container">
//             <div className="row">
//               <div className="col-lg-3 col-md-6">
//                 <div className="square-box">
//                   <img src={dealerIcon} alt="Dealer" />
//                   <h3>PREMIUM</h3>
//                   <h4>DEALER SUPPORT</h4>
//                 </div>
//               </div>
//               <div className="col-lg-3 col-md-6">
//                 <div className="square-box">
//                   <img src={managerIcon} alt="Manager" />
//                   <h3>DEDICATED</h3>
//                   <h4>ACCOUNT MANAGERS</h4>
//                 </div>
//               </div>
//               <div className="col-lg-3 col-md-6">
//                 <div className="square-box">
//                   <img src={speedIcon} alt="Speed" />
//                   <h3>BEST</h3>
//                   <h4>5G NETWORKS</h4>
//                 </div>
//               </div>
//               <div className="col-lg-3 col-md-6">
//                 <div className="square-box">
//                   <img src={networkIcon} alt="Network" />
//                   <h3>POWERED BY</h3>
//                   <h4>TELSTRA'S WHOLESALE NETWORK</h4>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         <section className="footer-contact-box">
//           <div className="container">
//             <div className="row">
//               <div className="col-lg-12 col-md-12">
//                 <center>
//                   <h2>We're here to help, Connect with us</h2>
//                 </center>
//               </div>
//               <br />
//               <br />
//               <div className="col-lg-7 col-md-6">
//                 <div className="footer-box">
//                   <div className="footer-contact">
//                     <img className="icon" src={phoneIcon} alt="Phone" />
//                     <h4>
//                       (02) 7259 7777 <span>(9am to 6pm - 7 Days)</span>
//                     </h4>
//                   </div>
//                   <div className="footer-contact">
//                     <img className="icon" src={mailIcon} alt="Mail" />
//                     <h4>dealersupport@telsim.com.au</h4>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-lg-5 col-md-6">
//                 <div className="footer-box">
//                   <center>
//                     <img src={qrIcon} alt="QR" />
//                   </center>
//                   <p>Scan the QR code to message us on WhatsApp</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </DashboardLayout>
//   );
// }

// export default HomeScreen;


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import bannerImg from "../../../../../../assets/images/ActivationHomeBanner.png";
import smallBannerImg from "../../../../../../assets/images/New-Dealer-Portal-Banner.png"
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

import dealerIcon from "../../../../../../assets/images/dealer-support.png";
import managerIcon from "../../../../../../assets/images/account-manager.png";
import speedIcon from "../../../../../../assets/images/5G-network.png";
import networkIcon from "../../../../../../assets/images/network.png";
import qrIcon from "../../../../../../assets/images/qr-code.png";
import fourGIcon from "../../../../../../assets/images/4G.png";
import fiveGIcon from "../../../../../../assets/images/5G.png";
import mailIcon from "../../../../../../assets/images/Mail.png";
import phoneIcon from "../../../../../../assets/images/Phone.png";
import { getApiHeader } from 'utlis/commonfunctions';
import Loader from './loader';

// TODO: replace with the real plan id of "$55.90 5G Premium Prepaid Plan"
const NEW_PLAN_ID = 20;

// New plan sits above the data only plan (13)
const PLAN_ORDER = [16, 17, 18, NEW_PLAN_ID, 13, 19];

// Data allowance (GB) per plan id
const PLAN_GB = {
  16: 15,
  17: 45,
  18: 80,
  [NEW_PLAN_ID]: 160,
  13: 100, // data-only plan
  19: 100,
};

// New plan for the NEW ACTIVATION side
const NEW_ACTIVATION_PLAN = {
  plan_id: NEW_PLAN_ID,
  actual_amount: 45.00,  // displayed price
  amount: 10,           // retailer price
  credits: 0,           // 0 -> shows "Only for $10"
};

// New plan for the PORT-IN side
const NEW_PORTIN_PLAN = {
  amount: NEW_PLAN_ID,  // port-in items are keyed by plan id
  credit: 0,
  retailerPrice: 10,    // shows "Only for $10"
};

const rank = (id) => {
  const i = PLAN_ORDER.indexOf(id);
  return i === -1 ? PLAN_ORDER.length : i;
};

function HomeScreen({ nextStep }) {
  const SERVER_URL = process.env.REACT_APP_API_URL;
  const [planData, setPlanData] = useState({});
  const [portinData, setPortinData] = useState([]);
  const [activationData, setActivationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    handleInitalLoad();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleInitalLoad = async () => {
    setLoading(true);
    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}wme-prepaid-activation/offerplan`, {}, { headers: headers });
      setPlanData(response?.data.data);

      const portInArray = Object.entries(response.data.data.portIn)
        .map(([amount, credit]) => ({
          amount: parseInt(amount),
          credit,
        }));

      // Add the new premium plan to port-ins if the API doesn't already return it
      if (!portInArray.some((p) => p.amount === NEW_PLAN_ID)) {
        portInArray.push(NEW_PORTIN_PLAN);
      }

      portInArray.sort((a, b) => rank(a.amount) - rank(b.amount));

      const activationArray = Object.entries(response.data.data.activation).map(([amount, credit]) => ({
        amount: parseInt(amount),
        credit,
      }));

      setPortinData({ portInArray, activationArray });

      const activationCreditAmountArray = [...(response?.data?.data?.activation_total_credit_amount || [])];

      // Add the new premium plan to new activations if the API doesn't already return it
      if (!activationCreditAmountArray.some((p) => p.plan_id === NEW_PLAN_ID)) {
        activationCreditAmountArray.push(NEW_ACTIVATION_PLAN);
      }

      activationCreditAmountArray.sort((a, b) => rank(a.plan_id) - rank(b.plan_id));

      setActivationData(activationCreditAmountArray);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div>
        <section id="hero-2" className="hero-2 d-flex align-items-center col-lg-12">
          {loading === true && <Loader />}
          <div className="container-fluid">
            <div className="hero-border">
              <div className="hero-background">
                <>
                  {isSmallScreen ? (
                    <img
                      src={smallBannerImg}
                      className="img-fluid banner-img"
                      style={{ borderRadius: "5px" }}
                      alt="Small Banner"
                    />
                  ) : (
                    <img
                      src={bannerImg}
                      className="img-fluid banner-img"
                      style={{ borderRadius: "5px" }}
                      alt="Large Banner"
                    />
                  )}
                </>

              </div>
            </div>
          </div>
        </section>
        <br />

        <div className="formbold-main-wrapper">
          <div className="container py-4">
            <div className="row">
              {/* PORT-INS Category */}
              <div className="col-md-12 col-lg-6 mb-4">
                <div className="text-center mb-3">
                  <h5 className="fw-bold">PORT-INS</h5>
                  <p className="activation-new-margin-heading">NOW FREE {planData?.port_in_unlimited_limit_count}% MARGIN</p>
                </div>

                {portinData?.portInArray?.map((item) => {
                  return (
                    <div
                      key={item?.amount}
                      className="d-flex flex-column flex-md-col flex-lg-row align-items-center rounded p-3 mb-3"
                      style={{ border: "1px solid #c11d6c" }}
                    >
                      <div className="amount-color mb-3 mb-md-0">
                        <h2>${item?.amount == 13 && "29.90"}{item?.amount == 16 && "25.00"}{item?.amount == 17 && "35.00"}{item?.amount == 18 && "33.00"}{item?.amount == 19 && "45.00"}{item?.amount == NEW_PLAN_ID && "45.00"}  <span style={{ fontSize: "20px" }}>{PLAN_GB[item?.amount] ?? 10}GB </span>
                        </h2>
                      </div>
                      <div className="network-img mb-3 mb-md-0">
                        <img src={fiveGIcon} alt="5G" />
                      </div>
                      <div className="responsive-activation-container" style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
                        <table className="table table-borderless">
                          <tbody>
                            <tr>
                              <td>
                                {item?.retailerPrice ? (
                                  <p style={{ textAlign: "center" }} className="new-font-activation">
                                    Only for <span></span>
                                    <strong style={{ fontWeight: "900", fontSize: "20px" }}>
                                      ${item?.retailerPrice}
                                    </strong>
                                  </p>
                                ) : (
                                  <p style={{ textAlign: "center" }} className="new-font-activation">
                                    <strong style={{ fontWeight: "900", fontSize: "20px" }}>
                                      {item?.credit}
                                    </strong>{" "}
                                    Credits Remaining
                                  </p>
                                )}
                              </td>
                            </tr>
                            <tr>
                              {item?.amount == 13 && (
                                <td>
                                  <button className="btn btn-amount-card">Data Only plan</button>
                                </td>
                              )}
                              <td>

                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* NEW ACTIVATION Category */}
              <div className="col-md-12 col-lg-6 mb-4">
                <div className="text-center mb-3">
                  <h5 className="fw-bold">NEW ACTIVATION</h5>
                  <p className="activation-new-margin-heading">
                    NOW {planData?.voucher_activation_plan_id_16_percentage}% MARGIN
                  </p>
                </div>

                {activationData?.map((item) => {
                  return (
                    <div
                      key={item?.plan_id}
                      className="d-flex flex-column flex-md-col flex-lg-row align-items-center rounded p-3 mb-3"
                      style={{ border: "1px solid #c11d6c" }}
                    >
                      <div className="amount-color mb-3 mb-md-0">
                        <h2>
                          ${item?.actual_amount?.toFixed(2)} <span style={{ fontSize: "20px" }}>{PLAN_GB[item?.plan_id] ?? 10}GB </span>
                        </h2>

                      </div>
                      <div className="network-img mb-3 mb-md-0">
                        <img src={fiveGIcon} alt="5G" />
                      </div>
                      <div className="responsive-activation-container" style={{ width: '100%', maxWidth: '300px', margin: '0 auto' }}>
                        <table className="table table-borderless">
                          <tbody>
                            <tr>
                              <td>

                                {item?.credits > 0 ?

                                  <p style={{ textAlign: "center" }} className="new-font-activation">

                                    <strong style={{ fontWeight: "900", fontSize: "20px" }}> {item?.credits} </strong>

                                    {item?.credits > 1 ? <> Credits </> : <> Credit </>} Remaining

                                  </p>

                                  :

                                  <p style={{ textAlign: "center" }} className="new-font-activation">
                                    Only for <span></span>
                                    <strong style={{ fontWeight: "900", fontSize: "20px" }}>
                                      ${item?.amount}
                                    </strong>
                                  </p>

                                }

                              </td>
                            </tr>
                            <tr>

                              {item?.plan_id == 13 && (
                                <td>
                                  <button className="btn btn-amount-card">Data Only plan</button>
                                </td>
                              )}

                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", marginBottom: "10px", cursor: "pointer", zIndex: 1000 }}>
          <button className="btn btn-amount-card" onClick={() => { nextStep() }}>Activate Prepaid SIM</button>
        </div>

        <p className='plans-notes' style={{ textAlign: "center", color: "#C11D6C", fontSize: "15px", padding: "10px" }}>Note: Please use $2 starter pack to avail credits.</p>

        <section className="service-square-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="square-box">
                  <img src={dealerIcon} alt="Dealer" />
                  <h3>PREMIUM</h3>
                  <h4>DEALER SUPPORT</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="square-box">
                  <img src={managerIcon} alt="Manager" />
                  <h3>DEDICATED</h3>
                  <h4>ACCOUNT MANAGERS</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="square-box">
                  <img src={speedIcon} alt="Speed" />
                  <h3>BEST</h3>
                  <h4>5G NETWORKS</h4>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="square-box">
                  <img src={networkIcon} alt="Network" />
                  <h3>POWERED BY</h3>
                  <h4>TELSTRA'S WHOLESALE NETWORK</h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="footer-contact-box">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <center>
                  <h2>We're here to help, Connect with us</h2>
                </center>
              </div>
              <br />
              <br />
              <div className="col-lg-7 col-md-6">
                <div className="footer-box">
                  <div className="footer-contact">
                    <img className="icon" src={phoneIcon} alt="Phone" />
                    <h4>
                      (02) 7259 7777 <span>(9am to 6pm - 7 Days)</span>
                    </h4>
                  </div>
                  <div className="footer-contact">
                    <img className="icon" src={mailIcon} alt="Mail" />
                    <h4>dealersupport@telsim.com.au</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-6">
                <div className="footer-box">
                  <center>
                    <img src={qrIcon} alt="QR" />
                  </center>
                  <p>Scan the QR code to message us on WhatsApp</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </DashboardLayout>
  );
}

export default HomeScreen;

